export default function PortfolioMissing() {
  const portfoliosLink = `${window.location.pathname}/allocations`

  return (
    <section>
      <header className="my-3 border-0 border-b border-neutral-9 py-1 text-sm uppercase text-neutral-3">
        Relationships
      </header>
      <div className="mx-2 mt-2 flex items-center rounded-md border bg-white p-2.5 text-sm shadow-sm">
        <a
          href={portfoliosLink}
          className="my-0.5 text-sm font-medium text-primary-4 hover:text-feature-6"
        >
          Portfolios
        </a>
      </div>
    </section>
  )
}
